import { rest } from 'msw';
import { AUTH_API_URL } from '../../config';
import { userFixture } from '../fixtures/auth.faker';

export const authHandler = [
    rest.get(AUTH_API_URL + '/v2/auth/me', (req, res, ctx) => {
        return res(
            // Respond with a 200 status code
            ctx.status(200),
            ctx.json(userFixture),
        );
    }),
    rest.get(AUTH_API_URL + '/v2/auth/refresh', (req, res, ctx) => {
        return res(
            // Respond with a 200 status code
            ctx.status(200),
            ctx.json({
                accessToken:
                    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJodHRwczovL3Rlc3RpbmcucXVhZG1pbmRzLmNvbS9hcGlzL2F1dGgtc2VydmljZSIsInN1YiI6IjYzNWFiYjU0NzRiOWQ2OTdhNDM5ZjU4MSIsImF1ZCI6WyJhcGkudXNlcnMucXVhZG1pbmRzIl0sImV4dGVybmFsSWQiOiIxMzcyNiIsImZpcnN0TmFtZSI6IkRhdmlkIiwibGFzdE5hbWUiOiJDYXJyaWxsbyIsImNvZGUiOiJkYXZpZC5jYXJyaWxsb0BxdWFkbWluZHMuY29tIiwicm9sZXMiOiJ1c2VyX2RlZmF1bHRfcm9sZSxhZG1pbiIsInBlcm1pc3Npb25zIjpbIm9yZ2FuaXphdGlvbnMucmVhZCIsIm9yZ2FuaXphdGlvbnMudXNlcnMuY3JlYXRlIiwidXNlcnMudXBkYXRlIiwib3JnYW5pemF0aW9ucy5pbnZpdGVzLnJlYWQiLCJvcmdhbml6YXRpb25zLmludml0ZXMuY3JlYXRlIiwidXNlcnMucmVhZCIsInVzZXJzLmRlbGV0ZSIsIm9yZ2FuaXphdGlvbnMudXNlcnMudXBkYXRlIiwib3JnYW5pemF0aW9ucy51c2Vycy5kZWxldGUiLCJvcmdhbml6YXRpb25zLnVzZXJzLnJlYWQiLCJvcmdhbml6YXRpb25zLmludml0ZXMuZGVsZXRlIiwiYWRtaW4iXSwiYXBwbGljYXRpb25zIjpbInNhYXMiXSwiYXBwbGljYXRpb25Nb2R1bGVzIjpbXSwib3JnYW5pemF0aW9ucyI6W3siaWQiOiI2MzVhYmI0Yzc0YjlkNjk3YTQzOWY0YWMiLCJlbWFpbCI6ImRhdmlkLmNhcnJpbGxvQHF1YWRtaW5kcy5jb20iLCJuYW1lIjoiRGF2aWQgQ2FycmlsbG8gQ29ycHMiLCJleHRlcm5hbElkIjoiMTM3MjYifV0sImN1cnJlbnRPcmdhbml6YXRpb24iOiI2MzVhYmI0Yzc0YjlkNjk3YTQzOWY0YWMiLCJ0eXBvbG9neSI6IlVTRVIiLCJ2ZXJzaW9uIjoiMS4xIiwiaWF0IjoxNzQ1NTAyMzIyLCJleHAiOjE3NDU1MDMyMjJ9.KlUm3dtXAN7DhRijfA_sJ6_ukgacXm7aO1iyed-GI8c',
            }),
        );
    }),
];
